import React from 'react';
import { WorkflowDuplicateDialog } from '@/components/WorkflowDuplicateDialog';
import type { Workflow } from '@/components/ApprovalStageWizard/types';

interface WorkflowDuplicateDialogWrapperProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  workflow: Workflow | null;
  onDuplicate: (
    workflowId: string,
    newName: string,
    options: {
      copyStages: boolean;
      copyRules: boolean;
      copyAssignments: boolean;
    }
  ) => Promise<void>;
}

export const WorkflowDuplicateDialogWrapper: React.FC<WorkflowDuplicateDialogWrapperProps> = ({
  open,
  onOpenChange,
  workflow,
  onDuplicate,
}) => {
  return (
    <WorkflowDuplicateDialog
      open={open}
      onOpenChange={onOpenChange}
      workflow={
        workflow
          ? {
              id: workflow.id,
              name: workflow.name,
              description: workflow.description || '',
              isActive: workflow.status === 'active',
              isDefault: false,
              createdAt: workflow.createdAt,
              createdBy: workflow.createdBy,
              version: 1,
              stages: workflow.stages.map((stage) => ({
                id: stage.id,
                workflowId: workflow.id,
                name: stage.name,
                description: stage.description || '',
                stageOrder: stage.order,
                approvalType: 'all' as const,
                requiredApprovals: 1,
                isActive: stage.status === 'configured',
                createdAt: workflow.createdAt,
                approvers: [],
              })),
              totalStages: workflow.stages.length,
              totalApprovers: 0,
              isInUse: (workflow.assignedToCount || 0) > 0,
            }
          : null
      }
      onDuplicate={onDuplicate}
    />
  );
};
